import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { isAdmin, isAreaAdmin, isSuperAdmin, isUser } from 'utils/utils';

const AuthLayout = () => {
  const { authToken, userData } = useSelector((store) => store.auth);
  const auth = !!authToken;

  return (
    <>
      {auth ? (
        <Outlet />
      ) : isSuperAdmin(userData?.roles) || isAreaAdmin(userData?.roles) ? (
        <Navigate to="/Stores" replace={true} />
      ) : isAdmin(userData?.roles) || isUser(userData?.roles) ? (
        <Navigate to="/StoreInfo/projects" replace={true} />
      ) : (
        <Navigate to="/login" replace={true} />
      )}
    </>
  );
};

export default AuthLayout;
